<template>
  <v-container fluid class="home">
    <SearchBar />
    <v-row>
      <div class="business">
        <img src="@/assets/business.png" />
        <div class="business-text">
          <p class="gotham-medium">Find the best deals on dental supply</p>
          <p class="gotham-medium">
            Search 100,000+ dental materials <br />
            from more than 500 suppliers
          </p>
        </div>
      </div>
    </v-row>
    <!-- <v-row class="px-110">
      <v-col
        cols="12"
        sm="6"
        md="4"
        lg="3"
        class="d-flex flex-column align-center"
        v-for="product in products"
        :key="product.name"
      >
        <product-card :product="product" />
      </v-col>
    </v-row> -->
    <v-row class="d-flex justify-center py-5">
      <v-btn @click="navigateToSearch"
        class="browse-products gotham-medium"
        outlined
        rounded
        x-large
        color="appGreen"
        >Browse All Products</v-btn
      >
    </v-row>
    <v-row class="world-map-section">
      <div class="world-map-wrapper w-100 d-flex justify-center">
        <div class="world-map">
          <img src="@/assets/world-map.png" />
          <p>
            BUY DENTAL EQUIPMENT OF <br />
            WORLD'S TOP BRANDS
          </p>
          <div class="logos">
            <div><img src="@/assets/3m.svg" /></div>
            <div><img src="@/assets/product-logo.svg" /></div>
            <div><img src="@/assets/nsk.svg" /></div>
            <div><img src="@/assets/tepe.svg" /></div>
          </div>
        </div>
      </div>
    </v-row>
    <home-footer class="d-none d-md-block" />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import HomeFooter from "@/components/Shared/HomeFooter/HomeFooter.vue";
//import ProductCard from "@/components/Shared/ProductCard/ProductCard.vue";
import algoliasearch from "algoliasearch/lite";
import "instantsearch.css/themes/satellite-min.css";
import VueCookie from "vue-cookie";
import auth from "@/auth/auth.js";
import SearchBar from "@/components/SearchBar/SearchBar.vue";
// import SubMenu from "@/components/Shared/SubMenu/SubMenu.vue";

const aa = require("search-insights");

aa("init", {
  appId: process.env.ALGOLIA_APP_ID,
  apiKey: process.env.ALGOLIA_ANALYTICS_KEY
});

if (VueCookie.get("token")) {
  aa("setUserToken", auth.decodeToken(VueCookie.get("token")).uid);
}

import { createInsightsMiddleware } from "instantsearch.js/es/middlewares";

const insightsMiddleware = createInsightsMiddleware({
  insightsClient: aa
});

export default {
  name: "HomeComponent",
  components: {
  HomeFooter,
  SearchBar
  },
  data: () => ({
    middlewares: [insightsMiddleware],
    searchClient: algoliasearch(
      process.env.ALGOLIA_APP_ID,
      process.env.ALGOLIA_API_KEY
    ),
    query: "",
    search: "",
    carousel: 0,
    showCategories: false
  }),
  methods: {
    navigateToProductPage(item, sendEvent) {
      this.evtCatalogueItemSelected(item);
      sendEvent("click", item, "Search Result Clicked");
      this.$router.push({
        name: "Product",
        params: {
          id: this.convertToSlug(item.name) + "-" + item.id
        }
      });
    },
    navigateToSearch() {
      this.$router.push({name: 'Search'})
    },

    onSelect(selected) {
      if (selected) {
        this.query = selected.item.name;
      }
    },
    convertToSlug(Text) {
      return Text.toLowerCase()
        .replace(/[^\w ]+/g, "")
        .replace(/ +/g, "-");
    },
    indicesToSuggestions(indices) {
      return indices.map(({ hits }) => ({ data: hits }));
    }
  },
  computed: mapState({
    products: state => state.product.products
  })
};
</script>
<style scoped lang="scss" src="./Home.scss"></style>
